import {FormControl, Grid} from "@mui/material";
import {OfficeSelect} from "../office-select/OfficeSelect";
import React, {useMemo} from "react";
import {Office} from "../../api/Model";
import {mapSetState, SetState} from "../../util/FormHandlers";


export function OfficeFilter<Filter extends {office: Office | null}>({filter, setFilter}: {
    filter: Filter,
    setFilter: SetState<Filter>,
}) {
    const setOffice = useMemo(
        () => mapSetState(setFilter, 'office'),
        [setFilter]
    );

    return (
        <Grid size={{lg: 2, md: 3, xs: 12}}>
            <FormControl fullWidth variant="outlined">
                <OfficeSelect
                    fullWidth
                    id="office-select"
                    label="Office"
                    office={filter.office}
                    setOffice={setOffice}
                />
            </FormControl>
        </Grid>
    );
}
